<template>
  <ColumnContent
    :title="context.service.name"
    class="px-2"
  >
    <a
      v-for="town in towns"
      :key="town.name"
      class="service-town d-flex text--text text-decoration-none mb-4 text-body-1"
      data-qa="service_town"
      :href="town.href"
    >
      <div
        class="mr-auto"
        data-qa="service_town_name"
      >
        {{ town.name }}
      </div>
      <div class="primary--text ml-2">
        от
        <span data-qa="service_town_price">{{ town.price }}</span>
      </div>
    </a>
  </ColumnContent>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useContextStore, useURLStore } from 'src/store'
import { ColumnContent } from 'src/layouts'
import formatPrice from 'src/functions/formatPrice'
import type { ContextStore } from 'src/components/pages/services/[...slug]/types'

const { context }: ContextStore = useContextStore()
const { reverseFull } = useURLStore()

const urlServiceCategory = (town: ContextStore['context']['towns'][number]) => (
  reverseFull({
    name: 'services_category',
    args: [town.translit, context.service.dclass.group, context.service.dclass.translit, context.service.translit],
  })
)

const urlServiceAll = (town: ContextStore['context']['towns'][number]) => (
  context.service.group
    ? reverseFull({
      name: 'services_all',
      args: [town.translit, context.service.group, context.service.translit],
    })
    : reverseFull({
      name: 'services_all',
      args: [town.translit, context.service.dclass.group, context.service.dclass.translit],
    })
)

const towns = computed<Array<{
  name: string
  href: string
  price: string
}>>(() => context.towns.map(town => ({
  href: context.is_category
    ? urlServiceCategory(town)
    : urlServiceAll(town),
  name: town.name,
  price: formatPrice({
    price: town.price,
    currencySymbol: context.currency.symbol,
  }),
})))
</script>

<style scoped lang="scss">
@import 'src/styles/index';
@import '~www/themes/doctors/common/variables';

.service-town {
  border-block-end: 1px dotted $ui-kit-text;

  &:hover {
    color: $ui-kit-text-error !important;
  }
}
</style>
